import React, {useEffect, useState} from "react";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import axios from "axios";
import {config} from "../../Helpers/env";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {dateConvert} from "../Utils/ConvertDate";
import {Link} from "react-router-dom";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {useDebounce} from "../Lab/useDebounce";
import {DoctorDateFilter} from "../DoctorsModule/WaitingList";
import {ReusableRouteTabs} from "../Utils/Dialogs/ReusableTabs";
import {history} from "../../Helpers/history";
import {useEmergencyPatientCount} from "./hooks/useEmergencyPatientCount";

const headData = [
    {id: 'count',                 label: 'Sl.',          hidden: false},
    {id: 'delivery_date_display', label: 'Delivery Date',hidden: false},
    {id: 'patient_number',        label: 'Patient No.',  hidden: false},
    {id: 'patient_name',          label: 'Patient Name', hidden: false},
    {id: 'phone_no',              label: 'Phone',        hidden: false},
    {id: 'kin_phone_no',          label: 'NOK Phone',    hidden: false},
    {id: 'delivery_mode_display', label: 'Mode',         hidden: false},
    {id: 'number_of_babies',      label: 'Babies',       hidden: false},
    {id: 'blood_loss_display',    label: 'EBL (ml)',     hidden: false},
    {id: 'condition_display',     label: 'Condition',    hidden: false},
    {id: 'doctor_name',           label: 'Clinician',    hidden: false},
    {id: 'action',                label: 'Action',       hidden: false},
];

const formatDateTime = (val) => {
    if (!val) return '—';
    try {
        return new Date(val).toLocaleString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
        });
    } catch { return val; }
};

const formatMode = (mode) => {
    if (!mode) return '—';
    return mode.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};

const conditionColor = (cond) => {
    if (cond === 'critical') return '#c62828';
    if (cond === 'unstable') return '#e65100';
    if (cond === 'stable')   return '#2e7d32';
    return '#555';
};

const bloodLossColor = (ml) => {
    const v = parseFloat(ml);
    if (isNaN(v)) return '#555';
    if (v >= 1000) return '#c62828';
    if (v >= 500)  return '#e65100';
    return '#2e7d32';
};

const GynDeliveredMothers = ({actions, snackbars}) => {

    const {emergency_count} = useEmergencyPatientCount(actions);

    const components = [
        {label: 'Active Patients',     path: '/gyn-and-obs-waiting-list'},
        {label: 'Missed Appointments', path: '/gyn-missed-appointments'},
        {label: 'Delivered Mothers',   path: '/gyn-delivered-mothers'},
        // {label: 'High Risk Mothers',   path: '/gyn-high-risk-mothers'},
        {label: 'Emergency Patients',  path: '/gyn-emergency-patients', badge: true, badge_count: emergency_count},
    ];

    const [date, setDate] = useState({start_date: dateConvert(), end_date: dateConvert()});
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({waitingList: [], loading: 'idle', total: 0});
    const [activePage, setActivePage] = useState(1);

    const [debouncedInputValue] = useDebounce(searchValue, 500);
    const {loading, total, waitingList} = data;
    const {start_date, end_date} = date;

    useEffect(() => {
        const formData = new FormData();
        formData.append('search',     debouncedInputValue);
        formData.append('start_date', start_date);
        formData.append('end_date',   end_date);
        formData.append('per_page',   rowsPerPage);

        setData(prev => ({...prev, loading: 'pending'}));

        axios.post(`${config.smsUrl}/obgyn/gyn_delivered_mothers/${activePage}`, formData)
            .then(res => {
                const dt  = res.data || {};
                const arr = dt.waiting_list || [];

                const items = arr.map((item, index) => ({
                    ...item,
                    count: ((activePage - 1) * rowsPerPage) + index + 1,
                    delivery_date_display: formatDateTime(item.delivery_date),
                    patient_name: `${item.first_name || ''} ${item.last_name || ''}`.trim(),
                    doctor_name: (`${item.doctor_first_name || ''} ${item.doctor_last_name || ''}`).trim() || '—',
                    delivery_mode_display: formatMode(item.delivery_mode),
                    number_of_babies: item.number_of_babies || 1,
                    blood_loss_display: item.estimated_blood_loss_ml ? (
                        <span style={{color: bloodLossColor(item.estimated_blood_loss_ml), fontWeight: 600}}>
                            {item.estimated_blood_loss_ml} ml
                        </span>
                    ) : '—',
                    condition_display: item.maternal_condition_post_delivery ? (
                        <span style={{color: conditionColor(item.maternal_condition_post_delivery), fontWeight: 600, textTransform: 'capitalize'}}>
                            {item.maternal_condition_post_delivery}
                        </span>
                    ) : '—',
                    action: (
                        <Link to={`/gyn-and-obs-delivery-record/${item.patient_number}/${item.visit_id}/1`}>
                            <button type="button" className="btn btn-sm small-btn sms-info-btn">View</button>
                        </Link>
                    ),
                }));

                setData({loading: 'success', waitingList: items, total: dt.total_count || 0});
            })
            .catch(err => {
                setData(prev => ({...prev, loading: 'error'}));
                logoutErrorMessage(err, null, actions);
            });
    }, [debouncedInputValue, activePage, rowsPerPage, start_date, end_date]);

    // const handleChangeDate        = e => setDate(prev => ({...prev, [e.target.name]: e.target.value}));
    const handleChangeDate = e => {const {name, value} = e.target;setDate(prev => ({...prev,[name]: value}));};
    const handleSearch            = e => { setSearchValue(e.target.value); setActivePage(1); setPage(0); };
    const handleChangePage        = (_, newPage) => { setPage(newPage); setActivePage(newPage + 1); };
    const handleChangeRowsPerPage = e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); setActivePage(1); };
    const handleChangeNextPage    = val => setActivePage(val);
    const closeSnackbar           = () => actions.snackbarActions.hideSnackbar();

    const {openBar, type, message} = snackbars;
    const isLoading  = loading === 'pending';
    const isSuccess  = loading === 'success';
    const isRejected = loading === 'error';

    const {headCells, all_hidden, handleAllHeadCells, handleHeadCells} = useHiddenColumns(headData);

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div data-testid="gyn-delivered-mothers" className="journals">
            <PageTitle title="Gyn Delivered Mothers"/>
            <SubHeader title="Gyn and Obs" subTitle="Delivered Mothers">
                <div className="header-icon-margin-right-zero">
                    <img src="/images/antenatal-blue.png"
                         className="icon-resize surgery-icon-tabs ante-natal-green" alt=""/>
                </div>
            </SubHeader>

            <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>

            <div className="mui-tables">
                <div className="row mb-0">
                    <div className="col-lg-8">
                        <DoctorDateFilter state={date} handleChange={handleChangeDate}/>
                    </div>
                </div>

                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>

                <CustomTable
                    title="Delivered Mothers"
                    customPage
                    handleChangeNextPage={handleChangeNextPage}
                    headData={headCells}
                    handler={handleSearch}
                    records={10}
                    total_count={total}
                    activePage={activePage}
                    data={waitingList}
                    colSpan={headCells.length}
                    term={searchValue}
                    handleHeadCells={handleHeadCells}
                    all_hidden={all_hidden}
                    handleAllHeadCells={handleAllHeadCells}
                    pagination={pagination}
                >
                    <TableBody>
                        {isLoading && (
                            <TableRow>
                                <TableCell colSpan={headCells.length} align="center">
                                    <img src="/images/smsloader.gif" alt="loader"/>
                                </TableCell>
                            </TableRow>
                        )}
                        {isSuccess && (
                            waitingList.length > 0
                                ? waitingList.slice(0, rowsPerPage).map((item, idx) => (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={idx} className="mui-table-row">
                                        {headCells.map(head => (
                                            <TableCell key={head.id} hidden={head.hidden}>
                                                {item[head.id]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                                : (
                                    <TableRow>
                                        <TableCell colSpan={headCells.length} align="center">
                                            No delivered mothers found for the selected date range.
                                        </TableCell>
                                    </TableRow>
                                )
                        )}
                        {isRejected && (
                            <TableRow>
                                <TableCell colSpan={headCells.length} align="center">
                                    The server did not return a valid response.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </CustomTable>
            </div>
        </div>
    );
};

function mapStateToProps(state) { return {snackbars: state.snackbar}; }
function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}};
}

export default connect(mapStateToProps, mapDispatchToProps)(GynDeliveredMothers);